/** Hero image placeholder — taller than section placeholders below. */
export const homepageHeroImagePlaceholderClassName =
  'w-full rounded-2xl bg-[#121820] shadow-[0_8px_48px_rgba(0,0,0,0.35)] min-h-[50vh] lg:h-[64vh]';

/** All homepage image placeholders below the hero (How + capability rows): same height, radius, shadow. */
export const homepageSectionImagePlaceholderClassName =
  'w-full rounded-2xl bg-[#121820] shadow-[0_8px_48px_rgba(0,0,0,0.35)] min-h-[42vh] lg:h-[52vh]';

/** Fills stretched grid/flex column (min 420px) so image column matches text height. */
export const homepageSectionImagePlaceholderStretchClassName =
  'w-full flex-1 min-h-[420px] h-full rounded-2xl bg-[#121820] shadow-[0_8px_48px_rgba(0,0,0,0.35)]';
